import { endOfDay } from "./endOfDay.js";
import { endOfMonth } from "./endOfMonth.js";
import { toDate } from "./toDate.js";

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param date - The date to check
 * @param options - An object with options
 *
 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
export function isLastDayOfMonth(date, options) {
  var _date = toDate(date, options === null || options === void 0 ? void 0 : options["in"]);
  return +endOfDay(_date, options) === +endOfMonth(_date, options);
}

// Fallback for modularized imports:
export default isLastDayOfMonth;